import React from 'react'
import { Link } from "react-router-dom";
import transition from "../transition";
import { Typewriter, Cursor } from "react-simple-typewriter";

const NotFound = () => (
  <div>
    <h1>
      <Typewriter className="typeWriter" words={['.joyastick', '.js', '404.js']} /><Cursor />
    </h1>
    <div className="mx-auto flex min-h-[calc(100vh-var(--nav-h))] max-w-xl flex-col items-center justify-center gap-6 px-4 text-center">
      <p className="text-8xl font-bold">404</p>
      <p className="text-xl font-medium">That page doesn't exist.</p>
      <Link to="/" className="rounded-full bg-emerald-100/75 px-5 py-2 font-bold shadow-lg transition-transform hover:scale-105">
        Back home
      </Link>
    </div>
  </div>
);

export default transition(NotFound);
